import React from "react"

import { TextBold } from "./common"

interface ShippingTextProps {}

const ShippingText: React.FC<ShippingTextProps> = () => (
  <TextBold>Orders over $49 ship free; Free 2-Day above $80</TextBold>
)

export default ShippingText
